import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Typography, Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseGeneralPages } from "../../UseGeneralPages";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../../../components/CustomPagination";
import { rsProgress, rsActiveMenu } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteRow from "../../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";

export default function Contacts(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { DeletePageContact, UpdatePageContact } = UseGeneralPages();
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    generalID: undefined,
    id: undefined,
  });
  const contactType = [
    { id: 1, type: "تلفن" },
    { id: 2, type: "آدرس" },
    { id: 3, type: "کد پستی" },
    { id: 4, type: "ایمیل" },
    { id: 5, type: "وب سایت" },
    { id: 6, type: "تصویر اصلی" },
  ];
  const [filt, setFilt] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    setFilt([
      {
        columnField: "title",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    return navigate("/generalpages/pageDetail/addPageContact", {
      state: {
        id: props.GeneralID,
        search: searchSubGroup,
        scrollTo: "PageContact",
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 350,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "type",
      headerName: "نوع",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {props.data?.length &&
            contactType.find((m) => m.id == cellValues.row.type)
              ? contactType.find((m) => m.id == cellValues.row.type).type
              : cellValues.row.type}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 170,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    id: cellValues.row.id,
                    generalID: cellValues.row.generalID,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("/generalpages/pageDetail/editPageContact", {
                    state: {
                      model: cellValues.row,
                      images: props.image ? props.image : [],
                      id: cellValues.row.generalID,
                      search: searchSubGroup,
                      scrollTo: "PageContact",
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  UpdatePageContact(model, "-", () =>
                    props.refresh(cellValues.row.generalID)
                  );
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (cellValues.row.rowIndex + 1 == props.data.length + 1) {
                  return;
                } else {
                  UpdatePageContact(model, "-", () =>
                    props.refresh(cellValues.row.generalID)
                  );
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchSubGroup}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                setSearchSubGroup(evt.target.value);
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "25rem" }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        rows={props.data ? props.data : []}
        columns={columns}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={props.data && props.data.length ? props.data.length : 1}
        enableRangeSelection={true}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: props.data && props.data.length ? props.data.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={""}
        callback={() => {
          setProgress(true);
          DeletePageContact(deleteState.id, () => {
            props.refresh(deleteState.generalID);
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
